module.exports = __webpack_public_path__ + "static/media/appDownloadButton_ios@2x.8b3cd728.png";